import React, { ChangeEvent } from "react";
import * as Styled from "../settingStyles";
import dayjs from "dayjs";
import TimeToMinutesConvert, {
  TimeToMinutesConvertVer1
} from "../Convert/timeConvert";
import MinuteToTimeConvert from "../Convert/minuteConvert";
import { useTranslation } from "react-i18next";

type plateSettingProps = {
  settingData: any;
  setSettingData: any;
  setSave: any;
  edit: boolean;
  timeAlert: boolean;
};

const PlateSettings = ({
  settingData,
  setSettingData,
  setSave,
  edit,
  timeAlert
}: plateSettingProps) => {
  const { t } = useTranslation();
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSave(false);

    if (parseInt(value) < 1) setSettingData({ ...settingData, [name]: "1" });
    else setSettingData({ ...settingData, [name]: value.slice(0, 2) });
  };

  const handleChangeInSelectBox = (e: ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setSave(false);
    setSettingData({ ...settingData, [name]: parseInt(value) });
  };

  return (
    <Styled.BoxWrapper>
      <div className="subTitle">{t("trans.001")}</div>
      <div className="box-list">
        <div className="box">
          <div className="inner">
            <div className="label">{t("trans.002")}</div>
            <Styled.Flexbox>
              <Styled.Input
                name="maxPlateReservationCount"
                type="number"
                onChange={handleChange}
                value={settingData?.maxPlateReservationCount || ""}
                disabled={edit}
                required
              />
              {/*<Styled.Unit>개</Styled.Unit>*/}
              <Styled.Unit>{t("trans.countUnit")}</Styled.Unit>
            </Styled.Flexbox>
          </div>
          <div className="description">
            <div>{t("trans.003")}</div>
            <div>{t("trans.004")}</div>
          </div>
        </div>
        <div className="box">
          <div className="inner">
            <div className="label">{t("trans.005")}</div>
            <Styled.Flexbox className="response_extra">
              <div className="item">
                <div>{t("trans.006")}</div>
                <Styled.CustomDate
                  name="plateBookingOpenTime"
                  placeholderText={t("trans.007")}
                  value={
                    dayjs(
                      TimeToMinutesConvert(settingData?.plateBookingOpenTime)
                    ).format("a h:mm") === "Invalid Date"
                      ? ""
                      : dayjs(
                          TimeToMinutesConvert(
                            settingData?.plateBookingOpenTime
                          )
                        ).format("a h:mm")
                  }
                  onChange={(time: any) => {
                    setSettingData({
                      ...settingData,
                      plateBookingOpenTime: MinuteToTimeConvert(time)
                    });
                    setSave(false);
                  }}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  disabled={edit}
                />
              </div>
              <div className="item">
                <div>{t("trans.008")}</div>
                <Styled.CustomDate
                  name="plateBookingCloseTime"
                  placeholderText={t("trans.007")}
                  value={
                    dayjs(
                      TimeToMinutesConvertVer1(
                        settingData?.plateBookingCloseTime
                      )
                    ).format("a h:mm") === "Invalid Date"
                      ? ""
                      : dayjs(
                          TimeToMinutesConvertVer1(
                            settingData?.plateBookingCloseTime
                          )
                        ).format("a h:mm")
                  }
                  onChange={(time: any) => {
                    setSettingData({
                      ...settingData,
                      plateBookingCloseTime: MinuteToTimeConvert(time)
                    });
                    setSave(false);
                  }}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={10}
                  disabled={edit}
                />
              </div>
            </Styled.Flexbox>
          </div>
          <div className="description">{t("trans.009")}</div>
          {timeAlert && <div style={{ color: "red" }}>{t("trans.010")}</div>}
        </div>
        <div className="box">
          <div className="inner">
            <div className="label">{t("trans.011")}</div>
            <Styled.Flexbox>
              <Styled.Input
                name="plateScheduleDaysToOpen"
                type="number"
                onChange={handleChange}
                value={settingData?.plateScheduleDaysToOpen || ""}
                disabled={edit}
                required
              />
              <Styled.Unit>{t("trans.days")}</Styled.Unit>
            </Styled.Flexbox>
          </div>
          <div className="description">
            <div>{t("trans.012")}</div>
            <div>{t("trans.013")}</div>
          </div>
        </div>
        {settingData?.modalSettingShowInSetting === 1 && (
          <div className="box">
            <div className="inner">
              <div>{t("trans.014")}</div>
              <Styled.Flexbox>
                <Styled.SelectBox
                  name="modalSettingShowModalYN"
                  onChange={handleChangeInSelectBox}
                  value={settingData.modalSettingShowModalYN}
                  disabled={edit}
                >
                  <option value={0}>{t("trans.015")}</option>
                  <option value={1}>{t("trans.016")}</option>
                </Styled.SelectBox>
              </Styled.Flexbox>
            </div>
            <div className="description">
              <div>{t("trans.017")}</div>
              <div>{t("trans.018")}</div>
            </div>
          </div>
        )}
      </div>
    </Styled.BoxWrapper>
  );
};

export default PlateSettings;
